import * as React from 'react';

import { ItemName as CommonItemName } from '@dndbeyond/character-common-components/es';
import { BaseInventoryContract, CharacterTheme, Constants, ItemUtils } from '@dndbeyond/character-rules-engine/es';

import { AttunementIcon } from '../../Icons';

type ItemNameRarityProp = 'common' | 'uncommon' | 'rare' | 'very-rare' | 'legendary' | 'artifact';

interface Props {
    item: BaseInventoryContract;
    nameOverride: string | null;
    isCustomized: boolean;
    onClick?: (item: BaseInventoryContract) => void;
    showIcons: boolean;
    className: string;
    theme: CharacterTheme;
}
//TODO this is a temp component to handle dataOriginType Item not being a fully derived Item
// should remove when dataOriginName can take a entityLookup
export default class BaseInventoryName extends React.PureComponent<Props> {
    static defaultProps = {
        nameOverride: null,
        showIcons: true,
        isCustomized: false,
        className: '',
    };

    handleClick = (): void => {
        const { onClick, item } = this.props;

        if (onClick) {
            onClick(item);
        }
    };

    getAttunementIconNode = (): React.ReactNode => {
        const { item, showIcons, theme } = this.props;

        if (!showIcons || !ItemUtils.isAttuned(item)) {
            return null;
        }

        return <AttunementIcon theme={theme} />;
    };

    render() {
        const { item, showIcons, className, isCustomized, nameOverride, onClick, theme } = this.props;

        let displayName: string | null = nameOverride;

        if (displayName === null) {
            displayName = ItemUtils.getDefinitionName(item);
        }

        if (!displayName) {
            displayName = 'Item';
        }

        let rarity: ItemNameRarityProp;
        switch (ItemUtils.getRarity(item)) {
            case Constants.ItemRarityNameEnum.ARTIFACT:
                rarity = 'artifact';
                break;

            case Constants.ItemRarityNameEnum.LEGENDARY:
                rarity = 'legendary';
                break;

            case Constants.ItemRarityNameEnum.VERY_RARE:
                rarity = 'very-rare';
                break;

            case Constants.ItemRarityNameEnum.RARE:
                rarity = 'rare';
                break;

            case Constants.ItemRarityNameEnum.UNCOMMON:
                rarity = 'uncommon';
                break;

            case Constants.ItemRarityNameEnum.COMMON:
            default:
                rarity = 'common';
                break;
        }

        return (
            <CommonItemName
                className={className}
                onClick={onClick ? this.handleClick : undefined}
                name={displayName}
                rarity={rarity}
                isCustomized={isCustomized}
                showIcons={showIcons}
                isDarkMode={theme?.isDarkMode}
                attunementIconNode={this.getAttunementIconNode()}
            />
        );
    }
}
